export default __webpack_public_path__ + "static/approach-1-04b79536a3557ebc5b3aaf358e573dd6.svg";